import React, { useRef, useState } from "react"
import { BiSearch } from "@react-icons/all-files/bi/BiSearch"
import { IoMdClose } from "@react-icons/all-files/io/IoMdClose"
import { Box, IconButton } from "theme-ui"
import { useBreakpointIndex } from "@theme-ui/match-media"
import * as ComponentStyle from "assets/css/components.module.css"
import GoogleSearch from "./google-search"
import styled from "@emotion/styled"

const PopperWrap = styled.div`
    width: 500px;
    background: #fff;
    position: absolute;
    z-index: 99;
    box-shadow: &.open {
        display: block;
    }

    &.hidden {
        display: none;
    }

    @media screen and (max-width: 500px) {
        width: 100%;
    }
`

const IconSearch = styled(IconButton)`
    padding: 0.5rem;
    margin-right: 1rem;
    cursor: pointer;
    background: #fdf5f2;
    border-radius: 50%;
    & svg {
        fill: ${(props) => props.theme.colors.secondary} !important;
    }
`
const SearchBar = () => {
    const bpi = useBreakpointIndex()
    const [isOpen, setIsOpen] = useState(false)
    const reference = useRef()
    const popper = useRef()
    const [popperPosition, setPopperPosition] = useState({
        top: 0,
        right: 0,
    })
    const togglePopup = () => {
        setIsOpen(!isOpen)
        const refObj = reference.current.getBoundingClientRect()
        console.log(reference.current.getBoundingClientRect())
        setPopperPosition({
            ...popperPosition,
            top: parseInt(refObj.bottom + 32),
            right: parseInt(refObj.left + refObj.width),
        })
    }
    return (
        <>
            <Box>
                <IconSearch ref={reference} onClick={togglePopup}>
                    {isOpen ? (
                        <span className={ComponentStyle.iconsMedium}>
                            <IoMdClose />
                        </span>
                    ) : (
                        <span className={ComponentStyle.iconsMedium}>
                            <BiSearch />
                        </span>
                    )}
                </IconSearch>
                <PopperWrap
                    ref={popper}
                    className={!isOpen ? "hidden" : "open"}
                    style={{
                        top:
                            bpi > 1
                                ? popperPosition.top
                                : popperPosition.top - 16,
                        bottom: 0,
                        right: 0,
                        left: bpi > 1 ? popperPosition.right : 0,
                        transform: bpi > 1 ? "translateX(-99%)" : "",
                    }}
                >
                    <GoogleSearch />
                </PopperWrap>
            </Box>
        </>
    )
}

export default SearchBar
